// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1Z5Js","label":"Category_label__d5Bg3","content":"Category_content__2bEUp","header":"Category_header__1t3-Z","location":"Category_location__2TdKw"};